import config from '@/config'
import { createAuthenticatedFetch } from '@/helpers/api/httpClient'

const apiFetch = createAuthenticatedFetch()

export const licenseSqlInstanceApi = {
	getActiveCount: async () => {
		const res = await apiFetch(`${config.API_URL}/api/subscription/license/sql-instances/active-count`)
		if (!res.ok) {
			const err = await res.json().catch(() => ({}))
			return Promise.reject(err)
		}
		return Number(await res.json())
	},
}
